import React, {Dispatch, SetStateAction, useEffect, useRef, useState} from 'react'
import {Translate} from "../../../../components/translate/Translate";
import {useTranslation} from "react-i18next";
import { useSelector } from 'react-redux';
import { categories } from '../../../../constants/categories';
import { translateCategorySlug } from "../../../../functions/translateCategorySlug";

interface ITimesheetHeaderCategoryProps {
	selected: {label: string, value: string} | null
	setSelected: Dispatch<SetStateAction<{label: string, value: string} | null>>
}

export const TimesheetHeaderCategory: React.FC<ITimesheetHeaderCategoryProps> = ({ selected, setSelected }) => {
	
	const { t } = useTranslation(), dropDownRef = useRef<HTMLDivElement>(null);
	const [isActive, setIsActive] = useState(false);

	useEffect(() => {
		setIsActive(false);
	}, [selected])

	useEffect(() => {
		if(!dropDownRef.current) return;

		function onClick(event: MouseEvent) {
			if(!dropDownRef.current?.contains(event.target as Node)) {
				setIsActive(false);
			}
		}

		document.body.addEventListener("click", onClick);

		return () => document.body.removeEventListener("click", onClick);
	}, [dropDownRef]);

	function handleSelect(category: ITimesheetHeaderCategoryProps["selected"]) {
		localStorage.setItem("ic_last_category", category?.value || "");
		setSelected(category);
	}
	
	return (
		<div className={`section-table__drop-down drop-down${isActive ? " is-active" : ""}`} ref={dropDownRef}>
			<button onClick={_ => setIsActive(prev => !prev)} className="section-table__drop-down-target drop-down__target" type="button">
				<span>
					<span>
						{!selected ? t("timesheet_page.categories.Category") : translateCategorySlug(t, selected.value)}
					</span>
				</span>
				<svg width="10" height="7" viewBox="0 0 10 7" className="drop-down__target--arrow">
					<use xlinkHref="#drop-down-arrow"></use>
				</svg>
			</button>
			<div className="section-table__drop-down-block drop-down__block is-full-list">
				<ul className="section-table__drop-down-list drop-down__list">
					{categories.map(category => (
						<li key={category.value}>
							<button type="button" onClick={_ => handleSelect(category)}>
								{translateCategorySlug(t, category.value)}
							</button>
						</li>
					))}
				</ul>
			</div>
		</div>
	)
}
